import { defineComponent as _defineComponent } from 'vue'
import { Customer } from '@/models/tenant';
import { customersService } from '@/services/tenants.service';
import { Routes } from '@/router/routes';
import CustomerCreationModal from '../../components/customers/CustomerCreationModal.vue';
import { UserType } from '@/models/userType';
import { hasCurrentUserPermission } from '@/utils/permissionUtils';
import TableActionButton from '@/components/tableWithActions/TableActionButton.vue';
import TableWithActions from '@/components/tableWithActions/TableWithActions.vue';
import { formatDateWithTime, searchByDateField } from '../../utils/table';
import { modalService } from '@/library-services/modal.service';
import { computed, getCurrentInstance, onMounted, ref } from 'vue';
import { useI18n } from '@/composables/i18n';
import { useRouter } from '@/composables/router';
import { dialogService } from '@/library-services/dialog.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'Customers',
  setup(__props) {

const { t } = useI18n();
const router = useRouter();

const customers = ref<Customer[]>([]);
const isLoading = ref(false);
const app = getCurrentInstance();

onMounted(async () => {
  await getCustomers();
});

function confirmDelete(customer: Customer): void {
  dialogService.confirmWithPromise({
    title: t('dialog.confirm_delete_title').toString(),
    message: t('confirmation.message', {
      action: t('action.delete').toString().toLowerCase(),
      entity: t('tenant.name').toString().toLowerCase(),
      name: customer.name,
    }).toString(),
    confirmText: t('dialog.confirm_delete').toString(),
    cancelText: t(`dialog.confirm_cancel`).toString(),
    type: 'is-danger',
    onConfirm: async () => await deleteCustomer(customer.id),
  });
}

async function editCustomer(customer: Customer) {
  await router.push({
    name: Routes.TenantDetail,
    params: { id: customer.id.toString() },
  });
}

async function getCustomers() {
  isLoading.value = true;
  customers.value = await customersService
    .get()
    .finally(() => (isLoading.value = false));
}

function createCustomer() {
  modalService.compositionApi.open(
    {
      component: CustomerCreationModal,
      events: {
        save: async () => await getCustomers(),
      },
    },
    app,
  );
}

async function deleteCustomer(id: number) {
  await customersService.delete(id).then(() => {
    customers.value = customers.value.filter((x) => x.id !== id);
  });
}

function filterCustomerIdDh(customer: Customer, filter: string) {
  return customer.tenantIdDh.toString().includes(filter.toLowerCase());
}

function orderColumnEllipsisTitle(row: any, column: any) {
  if (column.rootClasses.indexOf('order-column') !== -1) {
    return {
      title: row[column.field],
    };
  }
}

const canEditCustomers = computed(() =>
  hasCurrentUserPermission(UserType.SubsidiaryAdmin),
);

return { __sfc: true,t, router, customers, isLoading, app, confirmDelete, editCustomer, getCustomers, createCustomer, deleteCustomer, filterCustomerIdDh, orderColumnEllipsisTitle, canEditCustomers, TableActionButton, TableWithActions, formatDateWithTime, searchByDateField }
}

})